import React, { createContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import debounce from 'lodash.debounce';

export const QuickViewContext = createContext({
    openQuickView: () => {},
    closeQuickView: () => {},
    activeQuickView: null,
});

export function QuickViewProvider({ children }) {
    const [activeQuickView, setActiveQuickView] = useState(null);

    function openQuickView(quickView) {
        setActiveQuickView(quickView);
    }

    function closeQuickView() {
        setActiveQuickView(null);
    }

    useEffect(() => {
        function onResize() {
            // close quick view when the window is re-sized
            closeQuickView();
        }
        const debouncedResize = debounce(onResize, 500, { leading: true });

        window.addEventListener('resize', debouncedResize);
        return () => window.removeEventListener('resize', debouncedResize);
    }, []);

    return (
        <QuickViewContext.Provider value={{ openQuickView, closeQuickView, activeQuickView }}>
            {children}
        </QuickViewContext.Provider>
    );
}

QuickViewProvider.propTypes = {
    children: PropTypes.node,
};
